import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import { CreateUpdateHealthcareFacilityDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import DutySelector from '../Selects/DutySelector';

interface HealthcareFacilityGeneralTabProps {
  healthcareFacility: CreateUpdateHealthcareFacilityDto;
  propertyChange: (obj: Partial<CreateUpdateHealthcareFacilityDto>) => void;
  id?: string;
}

export const HealthcareFacilityGeneralTab: React.FC<
  HealthcareFacilityGeneralTabProps
> = props => {
  const [healthcareFacility, setHealthcareFacility] = useState(
    props.healthcareFacility,
  );

  useEffect(() => {
    setHealthcareFacility(props.healthcareFacility);
  }, [props.healthcareFacility]);

  const propertyChange = (obj: Partial<CreateUpdateHealthcareFacilityDto>) => {
    setHealthcareFacility({ ...healthcareFacility, ...obj });
    props.propertyChange(obj);
  };

  return (
    <div className="d-grid gap-3">
      <FormRow controlId="display_name" label="Wyświetlany opis">
        <Form.Control
          type="text"
          value={healthcareFacility?.displayName || ''}
          onChange={e => propertyChange({ displayName: e.target.value })}
        />
      </FormRow>

      <FormRow controlId="address" label="Adres">
        <Form.Control
          type="text"
          value={healthcareFacility?.address || ''}
          onChange={e => propertyChange({ address: e.target.value })}
        />
      </FormRow>
      <FormRow controlId="city" label="Miejscowość">
        <Form.Control
          type="text"
          value={healthcareFacility?.city || ''}
          onChange={e => propertyChange({ city: e.target.value })}
        />
      </FormRow>
      <FormRow controlId="duty" label="Grupa dyżurująca">
        <DutySelector
          value={healthcareFacility?.dutyId || ''}
          onChange={e => propertyChange({ dutyId: e.value })}
        />
      </FormRow>
      {!props.id && (
        <>
          <FormRow controlId="symbol_doctor" label="Symbol placówki lekarskiej">
            <Form.Control
              type="text"
              value={healthcareFacility?.symbolDoctor || ''}
              onChange={e => propertyChange({ symbolDoctor: e.target.value })}
            />
          </FormRow>
          <FormRow
            controlId="symbol_psychological"
            label="Symbol placówki psychologicznej"
          >
            <Form.Control
              type="text"
              value={healthcareFacility?.symbolPsychological || ''}
              onChange={e =>
                propertyChange({ symbolPsychological: e.target.value })
              }
            />
          </FormRow>
        </>
      )}
    </div>
  );
};
